import { reportContentConstants } from '../../_constants';

const initialState = { getReportContentLoading: true, data: '', error: false };

export function getReportContent(state = initialState, action) {

    switch (action.type) {
        case reportContentConstants.REQUEST_REPORT_CONTENT:
            return {
                getReportContentLoading: true,
                data: '',
                error: false
            };
        case reportContentConstants.RECEIVE_REPORT_CONTENT:

            return {
                getReportContentLoading: false,
                data: action.reportContent,
                error: false
            };
        case reportContentConstants.REPORT_CONTENT_ERROR:
            return {
                getReportContentLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/reportContent/getReportContent.reducer.js